<template>
  <div class="section section-center">
    <div class="login-wrap">
      <Welcome text="Добро пожаловать!">
        <div class="text-secondary ts-center">
          Нет аккаунта? Пройдите простую <router-link :to="{name: 'register'}" class="link">Регистрацию</router-link>
        </div>
      </Welcome>
      <LoginForm />
    </div>
  </div>
</template>

<script>
  import Welcome from '@/containers/auth/Welcome';
  import LoginForm from '@/containers/auth/LoginForm';

  export default {
    name: 'Login',
    components: {
      LoginForm,
      Welcome,
    },
  };
</script>
